import React from 'react';
import { Link } from 'react-router-dom';
import { ServicePageLayout } from '../components/ServicePageLayout';
import { PackagePricing } from '../components/PackagePricing';
import { FeatureItem } from '../components/FeatureItem';
import { RelatedLinks } from '../components/RelatedLinks';
import { packages } from '../data/packages';
const pkg = packages.find(p => p.slug === 'wash-wax')!;
const faqs = [{
  question: 'How much does a Wash & Wax cost?',
  answer: 'A Wash & Wax is $160 for small and mid-size vehicles and $180 for SUVs and crossovers. A limited-time $20 off the listed price is currently available.'
}, {
  question: 'What is included in a Wash & Wax?',
  answer: 'An exterior wash, window cleaning, vacuum, a light interior wipe-down, tire dressing, and a hybrid ceramic spray.'
}, {
  question: 'Is the hybrid ceramic spray the same as a ceramic coating?',
  answer: "No. Mike's Pro Detail offers hybrid ceramic spray, a sprayed-on protective product — not a professional ceramic coating."
}, {
  question: 'Do you come to my home or office?',
  answer: 'Yes. We bring our own water and detailing equipment to your home or office anywhere in Ventura County. We require access to a standard electrical outlet at the service location.'
}];
export function WashWaxPage() {
  return <ServicePageLayout title="Wash & Wax" subtitle="A Wash and Wax cleans your car, adds a protective layer, helps paint stay shiny, repel water, and dirt." metaDescription="Mobile Wash & Wax in Ventura County — exterior wash, vacuum, windows, tire dressing and hybrid ceramic spray. $160 SM/Mid, $180 SUV. $20 off now. Call or text 818-381-9905." schema={{
    '@type': 'Service',
    name: 'Wash & Wax',
    serviceType: 'Mobile Car Wash and Wax',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail"
    },
    areaServed: ['Ventura County', 'Camarillo', 'Ventura', 'Thousand Oaks'],
    description: pkg.summary,
    offers: [{
      '@type': 'Offer',
      price: '160',
      priceCurrency: 'USD',
      description: 'Small / mid-size vehicle'
    }, {
      '@type': 'Offer',
      price: '180',
      priceCurrency: 'USD',
      description: 'SUV / crossover'
    }]
  }} faqs={faqs} breadcrumbs={[{
    name: 'Home',
    item: 'https://www.fulldetailpro.com/'
  }, {
    name: 'Services',
    item: 'https://www.fulldetailpro.com/services'
  }, {
    name: 'Wash & Wax',
    item: 'https://www.fulldetailpro.com/wash-wax'
  }]} data-id="element-1095" data-mp="3b6imoab3arnh">
      <p data-id="element-1096" data-mp="17rzr8ty5zqgz">
        Our <strong data-id="element-1097" data-mp="12rc2yg1blnqg">Wash & Wax</strong> is the step up from a basic wash: a
        thorough clean inside and out, finished with a{' '}
        <Link to="/services/hybrid-ceramic-spray" data-id="element-1098" data-mp="xzaja91touqe">hybrid ceramic spray</Link>{' '}
        that leaves a protective, glossy layer on your paint — performed at your
        home or office anywhere in Ventura County.
      </p>

      <PackagePricing pkg={pkg} data-id="element-1099" data-mp="1qi7tzaxycewn" />

      <figure className="not-prose my-10" data-id="element-1100" data-mp="1lpwsw4rh6n2i">
        <img src="https://cdn.magicpatterns.com/uploads/bNVZWuDfAH9gZxv5SBhs7n/Blue_BMW_SUV.jpg" alt="Blue BMW SUV after a mobile exterior wash with hybrid ceramic spray" loading="lazy" decoding="async" className="w-full h-auto rounded-xl border border-zinc-800" data-id="element-1101" data-mp="1lovcrlvlradx" />
      </figure>

      <h2 data-id="element-1102" data-mp="22yzcaukh6stp">Benefits of a Wash & Wax</h2>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-1103" data-mp="22xxnzoeg89u1">
        <FeatureItem data-id="element-1104" data-mp="27yv5rzvjr1v0">
          <strong data-id="element-1105" data-mp="27zdcjqfu4yh6">Clean inside and out:</strong> exterior wash, windows,
          vacuum, and a light interior wipe-down.
        </FeatureItem>
        <FeatureItem data-id="element-1106" data-mp="2cvlutcpbx7sk">
          <strong data-id="element-1107" data-mp="2gys0ai4mauxz">A protective layer:</strong> the hybrid ceramic spray helps
          paint stay shiny.
        </FeatureItem>
        <FeatureItem data-id="element-1108" data-mp="2lqrurv1x4vn6">
          <strong data-id="element-1109" data-mp="2lq9xcv3isbdo">Repels water and dirt:</strong> a protected finish sheds
          water and road grime more easily between washes.
        </FeatureItem>
        <FeatureItem data-id="element-1110" data-mp="2vog0th4z5pkn">
          <strong data-id="element-1111" data-mp="2voz7g1p6crjd">Finished details:</strong> tire dressing for a complete look.
        </FeatureItem>
      </ul>

      <h2 data-id="element-1112" data-mp="30nsk5rwn0eih">Want a Deeper Clean?</h2>
      <p data-id="element-1113" data-mp="30kmvuevu1gnt">
        If your interior needs more than a wipe-down, the{' '}
        <Link to="/full-detail" data-id="element-1114" data-mp="175me7zt5cwo">Full Detail</Link> adds a complete interior
        detail and clay bar treatment. For a lighter maintenance wash on two or
        more cars, see the <Link to="/basic-wash" data-id="element-1115" data-mp="axrwxnso3d8i">Basic Wash</Link>.
      </p>

      <h2 data-id="element-1116" data-mp="5zqcayflf5ux">Related Services</h2>
      <RelatedLinks links={[['/full-detail', 'Full Detail'], ['/basic-wash', 'Basic Wash'], ['/services/hybrid-ceramic-spray', 'Hybrid Ceramic Spray'], ['/specials', 'Current Specials']]} data-id="element-1117" data-mp="5zgmbaujsyp8" />
    </ServicePageLayout>;
}